export default {
  table_ordering: 'Pedido en mesa',
  table: 'Mesa',
  pickup_or_delivery: 'Recogida o entrega',
  asap: 'Lo antes posible',
  served_in: 'Servido en {{time}} min',
  not_taking_orders: 'No acepta pedidos',
  not_your_table: '¿No es tu mesa? Escanea el código de la tuya.',
  eating_here: {
    title: '¿Comes aquí?',
    back_to_table: 'Pedido para {{table}}. Te lo llevamos.',
    scan_code: 'Escanea el código QR de tu mesa para pedir en ella.',
  },
  notes: {
    table_unavailable: {
      title: 'El código QR de esta mesa ya no funciona.',
      text: 'Pregunta al personal. Aún puedes pedir para recoger.',
      text_no_pickup: 'Pregunta al personal.',
    },
    table_ordering_off: {
      title: 'Pedir en la mesa no está disponible ahora mismo.',
      text: 'En su lugar, puedes pedir para recoger.',
    },
    load_failed: {
      title: 'No se pudo cargar tu mesa.',
      text: 'Escanea de nuevo el código QR.',
    },
    closed: {
      title: 'Cerrado ahora mismo.',
      text: 'Puedes pedir en tu mesa a partir de las {{time}}.',
      text_later: 'Podrás pedir en tu mesa cuando volvamos a abrir.',
    },
    paused: {
      title: 'No se aceptan pedidos ahora mismo.',
      text: 'Pregunta al personal o inténtalo de nuevo en unos minutos.',
    },
  },
  cart: {
    closed: 'Cerrado ahora. Puedes pedir en tu mesa a partir de las {{time}}. Tu cesta se guarda hasta entonces.',
    closed_later: 'Cerrado ahora. Tu cesta se guarda hasta que volvamos a abrir.',
    paused: 'No se aceptan pedidos ahora mismo. Tu cesta se guarda. Pregunta al personal.',
  },
  cash_note: 'Paga en efectivo en el mostrador.',
  confirmation: {
    bring_to_table: 'Te llevaremos el pedido a tu mesa.',
    your_table: 'Tu mesa',
    moved_table: '¿Te has cambiado de mesa? Dile al personal tu número de pedido <strong>{{number}}</strong>.',
  },
  served: 'Servido',
};
